import { useLocalStorage } from '@mantine/hooks';

/**
 * Persisted left/right panel collapse state. The default `inbox` scope is
 * shared across the WhatsApp, Messenger and Instagram inboxes so a "hide the
 * conversation list" / "hide the contact panel" preference survives reloads and
 * channel switches; pass a distinct scope (e.g. `botbuilder`) for an unrelated
 * surface. Keys mirror the `leadsync.*` localStorage convention.
 */
export function usePanelCollapse(scope = 'inbox') {
  const [leftCollapsed, setLeftCollapsed] = useLocalStorage<boolean>({
    key: `leadsync.${scope}.leftCollapsed`,
    defaultValue: false,
  });
  const [rightCollapsed, setRightCollapsed] = useLocalStorage<boolean>({
    key: `leadsync.${scope}.rightCollapsed`,
    defaultValue: false,
  });
  return {
    leftCollapsed,
    rightCollapsed,
    toggleLeft: () => setLeftCollapsed((v) => !v),
    toggleRight: () => setRightCollapsed((v) => !v),
  };
}
